import { Route } from "src/types/interfaces/Route";
import { CustomUsers as UsersIcon } from "./src/../../icons/custom-users";
import { Key as KeyIcon } from "src/icons/key";

export const routes: Route[] = [
  { icon: UsersIcon, title: "users.title", href: "/users" },
  { icon: KeyIcon, title: "keySetLimit.title", href: "/key-sets" },
];
